import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import BanderaDominicana from "../imgs/bandera-dr.png"

// import USFlag from "../imgs/USFlag.svg";
// import SpainFlag from "../imgs/SpainFlag.svg";

export default function Navbar() {
  const [selectedOption, setSelectedOption] = useState(null);
  const [t,i18n] = useTranslation("global");
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  
  const options = [
  { value: "es", label: (
  <div className="flex font-montserrat"><img src={require("../imgs/spainflag.png")} className="w-[25.5px] h-[17.53px] mr-1"></img>Español</div>)},
  { value: "en", label:(
  <div className="flex font-montserrat"><img src={require("../imgs/usflag.png")} className="w-[25.5px] h-[17.53px] mr-1"></img>English</div>)},
];
  const handleChange = (selectedOption) => {
    i18n.changeLanguage(selectedOption.value)
    localStorage.setItem("lng",selectedOption.value)
    switch(i18n.language){
        case "es": setSelectedOption(0); break;
        case "en": setSelectedOption(1); break;
        default: break;     

      }
  }

  useEffect(()=>{
    if(!localStorage.getItem("lng")){
      setSelectedOption(0)
    }
    else{
      switch(i18n.language){
        case "es": setSelectedOption(0); break;
        case "en": setSelectedOption(1); break;
        default: break;     

      }
      
    }
  },[])
    
  

  return (
    <>
      <nav className="print:hidden relative flex flex-wrap items-center justify-between px-2 py-3 bg-transparent mb-3 pr-20">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <a
              className="text-sm font-montserrat font-medium text-[16px] leading-relaxed inline-flex py-2 whitespace-nowrap text-black"
              href="https://educacionlaboral.com.do"
            >
              Educación Laboral

              <img src={BanderaDominicana} className="ml-3 mt-[4.5px] w-[25.5px] h-[17.53px]"></img>

            </a>
            
            <div
              className="text-black cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <svg className="ml-[8rem]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
            </div>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center" +
              (navbarOpen ? " flex" : " hidden")
            }
            id="example-navbar-danger"
          >
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
              <li className="nav-item">
                <a
                  className="px-8 py-2 flex items-center font-montserrat font-medium  leading-snug text-black hover:opacity-75"
                  href="/calculadora-de-salarios"
                >
                  <i className="fab fa-facebook-square text-lg leading-lg text-black opacity-75"></i><span className="ml-2">{t("navbar.home")}</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="px-8 py-2 flex items-center font-montserrat font-medium  leading-snug text-black hover:opacity-75"
                  href="/calculadora-de-salarios/datos"
                >
                  <i className="fab fa-twitter text-lg leading-lg text-black opacity-75"></i><span className="ml-2">{t("navbar.calculate")}</span>
                </a>
              </li>
              <li className="nav-item">
                {/* <a
                  className="px-8 py-2 flex items-center font-montserrat font-medium  leading-snug text-black hover:opacity-75 hidden"
                  href="/calculadora-de-salarios/referencias"
                >
                  <i className="fab fa-pinterest text-lg leading-lg text-black opacity-75"></i><span className="ml-2 hidden">Referencias</span>
                </a> */}
                <Select
        value={options[selectedOption]}
        options={options}
        onChange={handleChange}
        
      />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}